export default __webpack_public_path__ + "static/media/dashboard.8d9406bb.svg";